import moment from "moment";

export function compareStrings(a, b) {
    // Assuming you want case-insensitive comparison
    a = a.toLowerCase();
    b = b.toLowerCase();

    return (a < b) ? -1 : (a > b) ? 1 : 0;
}

export function isAuditor(currentUser) {
    return hasRole(currentUser, "ROLE_AUDITOR");
}

export function isViewer(currentUser) {
    return hasRole(currentUser, "ROLE_VIEWER");
}

function hasRole(currentUser, roleName) {
    if (currentUser && currentUser.authorities) {
        return Object.values(currentUser.authorities).some(role => {
            const authority = typeof role === 'string' ? role : (role.authority || role.type || role.name);
            return authority === roleName;
        });
    }
    return false;
}

export function expiredDateStyle(value) {
    let color = 'white';
    let textFontWeight = 'normal';
    console.log('value', value);
    if (value !== undefined && value !== '') {
        let nowInMilliseconds = moment().valueOf();
        let expiryInMilliseconds = moment(value, 'DD/MM/YYYY').valueOf();
        if (expiryInMilliseconds < nowInMilliseconds) {
            color = 'red';
            textFontWeight = 'bold';
        } else {
            color = 'black';
        }
    }
    return {
        color: color,
        fontWeight: textFontWeight,
    }
}

export function expiredDateStyleForMuiTable(value) {
    let color = 'white';
    let textFontWeight = 'normal';
    console.log('value', value);
    if (value !== undefined && value !== '') {
        let nowInMilliseconds = moment().valueOf();
        let expiryInMilliseconds = moment(value).valueOf();
        if (expiryInMilliseconds < nowInMilliseconds) {
            color = 'red';
            textFontWeight = 'bold';
        } else {
            color = 'black';
        }
    }
    return {
        color: color,
        fontWeight: textFontWeight,
    }
}